// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"986":"edfad990","8013":"edfad990"}[chunkId] + ".chunk.css";
};